import React, { useState } from 'react'
import PropTypes from 'prop-types'
import AddMember from '../../inputs/add-member'
import EditMember from '../edit-member'
import { formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input'
import { ajaxGet } from '../../../../ajax'

const TeamMembers = ({league, team, members, setMembers, onAlert}) => {
  const skillLevels = {0: 'Beginner', 1: 'Intermediate', 2: 'Advanced', 3: 'Expert'}
  const [newMember, setNewMember] = useState(null)
  const [editMember, setEditMember] = useState(null)
  const filteredMembers = members.filter(m => !m._destroy)
  const canAddPlayer = filteredMembers.length < league.max_players

  const presentsInTeam = (playerId) => {
    const memberIndex = filteredMembers.findIndex(m => m.player_id == playerId)
    return memberIndex != -1
  }

  const presentsInLeague = async (playerId) => {
    const response = await ajaxGet(`/admins/leagues/${league.id}/members/${playerId}`)
    const json = await response.json()

    return !!json.member
  }

  const onAddMember = async (data) => {
    if (presentsInTeam(data.player_id)) return onAlert(`Player ${data.name} is already in this team`)
    if (await presentsInLeague(data.player_id)) return onAlert(`Player ${data.name} can only be added once to the same league`)

    setMembers([data, ...members])
    setNewMember(null)
  }  

  const onDeleteMember = (e, member) => {
    e && e.preventDefault()
    const memberIndex = members.findIndex(m => { return m.player_id == member.player_id })
    
    if (member.id) {
      const updatedMember = { ...members[memberIndex], _destroy: true }
      setMembers([
        ...members.slice(0, memberIndex), 
        updatedMember,
        ...members.slice(memberIndex + 1, members.length)
      ])  
    } else {
      setMembers([
        ...members.slice(0, memberIndex), 
        ...members.slice(memberIndex + 1, memberIndex.length)
      ])
    }
  }

  const onUpdateMember = (member) => {
    setEditMember(null)
    const memberIndex = members.findIndex(m => { return m.player_id == member.player_id })
    const updatedMember = { ...members[memberIndex], ...member }
    setMembers([
      ...members.slice(0, memberIndex), 
      updatedMember,
      ...members.slice(memberIndex + 1, members.length)
    ])
  }

  const clickEditMember = (e, member) => {
    e.preventDefault()
    setEditMember(member)
  }

  const formattedPhone = member => {
    return member.country_code && member.country_code.toLowerCase() != 'us' ? formatPhoneNumberIntl(member.phone) : formatPhoneNumber(member.phone)
  }

  const membersList = () => {
    return <table className='team-members-table'>
      <thead>
        <tr>
          <th>NAME</th>
          <th>PHONE</th>
          <th>POSITION</th>
          <th>LEVEL</th>
          <th>CPT</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        { filteredMembers.map((member, i) => {
            const skillLevel = skillLevels[member.skill_level]

            return <tr key={i} className='team-member'>
              <td>
                <div className='team-member-name'>
                  <img src={member.image_url || '/images/ic_user@2x.png'} />
                  <span>{member.name}</span>
                </div>
              </td>
              <td>
                <div className='team-member-phone'>
                  {member.phone && formattedPhone(member) || ' '}
                </div>
              </td>
              <td>{member.prefer_position && <div className='team-member-position'>{member.prefer_position}</div>}</td>
              <td>{skillLevel && <div className={`team-member-skill-level ${skillLevel.toLowerCase()}`}>{skillLevel}</div>}</td>
              <td>{ member.captain && <div className='team-member-captain' />}</td>
              <td>
                <button className='team-member-edit-button' onClick={(e) => clickEditMember(e, member)}></button>
              </td>
              <td>
                <button className='team-member-delete-button' onClick={(e) => onDeleteMember(e, member)}></button>
              </td>
            </tr>
          })
        }
      </tbody>
    </table>
  }

  return <div className='team-members-section'>
    { canAddPlayer && 
      <AddMember
        disabled={!newMember}
        openLeague={league.open}
        member={newMember}
        setMember={setNewMember}
        onAddMember={onAddMember}
      />
    }
    { !canAddPlayer && 
      <div className='team-members-limit'>{`The maximum number of players per team for this League is: ${league.max_players}`}</div>
    }
    <div className='team-members-table-wrap'>
      {membersList()}
    </div>
    { editMember && 
      <EditMember
        leagueId={league.id}
        teamId={team.id}
        member={editMember}
        onClose={() => setEditMember(null)}
        onUpdate={(member) => onUpdateMember(member)}
        onDelete={(member) => onDeleteMember(null, member)}
      />
    }
  </div>
}

TeamMembers.propTypes = {
  league: PropTypes.object.isRequired,
  team: PropTypes.object.isRequired,
  members: PropTypes.array.isRequired,
  setMembers: PropTypes.func.isRequired,
  onAlert: PropTypes.func.isRequired,
}

export default TeamMembers
